import { useEffect, useState } from 'react';

export const usePaginatedState = <T>(data: T[] | undefined, currentPage: number) => {
  const [paginatedState, setPaginatedState] = useState<T[]>([]);

  useEffect(() => {
    if (!data) {
      return;
    }

    setPaginatedState((prev) => (currentPage === 1 ? data : [...prev, ...data]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return [paginatedState, setPaginatedState] as const;
};
